import { connectInfiniteHits } from "instantsearch.js/es/connectors";
import SITE_LANGUAGE from "../../partials/siteLanguage";
import { highlight } from "instantsearch.js/es/helpers";
import { translate } from "../translate";
import { chevronDown, pdf, external } from "./svgs";
import { defaultPurchaseOptions, friendlyPurchaseOptionLabel } from "./generate-fund-codes";
import {
	getNumericColClasses,
	buildAllFundCodes,
	fillInDatesFromFirstItem,
	getPrimaryFundId
} from "./fund-listing-utils";
import { fundFacts, kypReport } from "../fundLinks";
import fundDetail from "../../components/fundDetail";
const helpers = fundDetail();

/*
		this custom hits connector allows us to get the results into the table format
		- the infinite hits connector just allows for lazy loading results (if there are anymore)
 */
let lastRenderArgs;
let legalDatesFilled = false;
const customInfiniteHits = connectInfiniteHits(
	(renderArgs, isFirstRender) => {
		const { hits, showMore, widgetParams } = renderArgs;
		const { container } = widgetParams;

		if (!container) {
			console.warn('infinite hits is missing a container');
			return;
		}

		lastRenderArgs = renderArgs;

		if (isFirstRender) {
			const sentinel = document.createElement('div');
			sentinel.classList.add('sentinel')
			container.appendChild(document.createElement('tbody'));
			container.appendChild(sentinel);

			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
						showMore();
					}
				});
			});

			observer.observe(sentinel);

			return;
		}

		if (!legalDatesFilled && hits.length > 0) {
			fillInDatesFromFirstItem(hits[0]);
			legalDatesFilled = true;
		}

		container.querySelector('tbody').innerHTML = hits.length <= 0
			? `<tr><td colspan="9" class="p-4 font-bold text-center">${translate('No results')}</td></tr>`
			: hits.map(hit => {
				const primaryFundId = getPrimaryFundId(hit);
				return (
					`<tr class="border-b border-grayBrand-tablehead fund-detail-row">
						<td class="w-1/2 pl-3 pr-4 py-4" data-value="${hit.name}">
							<a href="/fund/${primaryFundId}" class="block">
								<strong>${highlight({ attribute: 'name', hit })}</strong>
							</a>
							<details class="fund-details cursor-pointer js-details" onclick="this.closest('.fund-detail-row').classList.toggle('open')">
								<summary class="flex flex-row text-xs text-grayBrand-details js-summary">
									${translate('Fund Details')}
									${chevronDown}
								</summary>
								<div class="flex flex-row mt-4 gap-12" style="width: calc(140% + 20px);">
									<div class="flex flex-col">
										<span class="text-xs font-bold mb-2">${translate('Fund Codes')}</span>
										
										${defaultPurchaseOptions(hit.purchaseOptions, hit.name).map(option => {
											return (
												`<div class="px-3 py-1 mb-1 mr-2 border-2 border-blackBrand hover:border-blueBrand hover:text-blueBrand text-14">
													<a class="inline-block" href="/fund/${option.fundId}">
														${friendlyPurchaseOptionLabel(option)}
													</a>
												</div>
												`
										)}).join(' ')}
									</div>
									<div>
										<span class="list-none text-xs font-bold my-2">${translate('All Fund Codes')}</span>	
										${hit.purchaseOptions.map(option => {
											return `${buildAllFundCodes(option)}`
										}).join(' ')}										
									</div>
									<ul class="mt-1 text-xs flex flex-col items-end">
										<span class="font-bold mb-1">${translate('More Information')}</span>
										<li>
											<a href="https://bmomf.lipperweb.com/bmomf/Pdf/?symbol=${primaryFundId}&lang=${SITE_LANGUAGE}" class="hover:text-blueBrand flex flex-row my-1">
												${translate('Fund Profile (PDF)')}
												${pdf}
											</a>
										</li>
										<li>
											<a href="${fundFacts(hit.objectID)}" class="hover:text-blueBrand flex flex-row my-1">
												${translate('Fund Facts')}
												${pdf}
											</a>										
										</li>
										<li>
											<a href="/fund/${primaryFundId}#under-the-hood" class="hover:text-blueBrand flex flex-row my-1">
												${translate('Top Holdings')}
												${external}
											</a>
										</li>
										${kypReport(hit.objectID) ? (
											`<li>
													<a href="${kypReport(hit.objectID)}" class="hover:text-blueBrand flex flex-row my-1">
													${translate('KYP Report')}
													</a>	
											</li>`
										) : ''}
									</ul>
								</div>
							</details>
						</td>
						<td class="pr-4 py-4 align-middle text-center whitespace-no-wrap" data-value="${hit.primary.nav.value}">
							${helpers.formatNavPrice(hit.primary.nav.value, 4)}
						</td>
						<td class="${getNumericColClasses(hit.primary.performance.ytd)}" data-value="${hit.primary.performance.ytd}">
							${hit.primary.performance.ytd ? helpers.formatNumber(hit.primary.performance.ytd) : "&mdash;"}
						</td>
						<td class="${getNumericColClasses(hit.primary.performance['1year'])}" data-value="${hit.primary.performance['1year']}">
							${hit.primary.performance['1year'] ? helpers.formatNumber(hit.primary.performance['1year']) : "&mdash;"}
						</td>
						<td class="${getNumericColClasses(hit.primary.performance['3year'])}" data-value="${hit.primary.performance['3year']}">
							${hit.primary.performance['3year'] ? helpers.formatNumber(hit.primary.performance['3year']) : "&mdash;"}
						</td>
						<td class="${getNumericColClasses(hit.primary.performance['5year'])}" data-value="${hit.primary.performance['5year']}">
							${hit.primary.performance['5year'] ? helpers.formatNumber(hit.primary.performance['5year']) : "&mdash;"}
						</td>
						<td class="${getNumericColClasses(hit.primary.performance['10year'])}" data-value="${hit.primary.performance['10year']}">
							${hit.primary.performance['10year'] ? helpers.formatNumber(hit.primary.performance['10year']) : "&mdash;"}
						</td>
						<td class="${getNumericColClasses(hit.primary.performance.inception)}" data-value="${hit.primary.performance.inception}">
							${hit.primary.performance.inception ? helpers.formatNumber(hit.primary.performance.inception): "&mdash;"}
						</td>
          </tr>`
				)
			})
			.join('');
	}
);

export default customInfiniteHits;

